import { PrinterIcon, LayersIcon, SparklesIcon, LifeBuoyIcon, AwardIcon } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export interface Bonus {
  icon: LucideIcon
  title: string
  price: string
}

export const bonuses: Bonus[] = [
  {
    icon: PrinterIcon,
    title: 'Schede Operative Stampabili: Modelli Riutilizzabili + Progetti Stagionali',
    price: '19 €',
  },
  {
    icon: LayersIcon,
    title: 'Flashcard: I Grandi Maestri dell’Arte (dalla Preistoria al Contemporaneo)',
    price: '19 €',
  },
  {
    icon: SparklesIcon,
    title: 'Arte Senza Materiali: 40 Attività Senza Tempere, Pennelli o Materiale Costoso',
    price: '27 €',
  },
  {
    icon: LifeBuoyIcon,
    title: 'Il Kit di Sopravvivenza per l’Insegnante Non Artista',
    price: '36 €',
  },
  {
    icon: AwardIcon,
    title: 'Portfolio dell’Artista + Diploma di Percorso Completo (8 Volumi)',
    price: '27 €',
  },
]
